import {
  Button,
  Input,
  List,
  Modal,
  Popconfirm,
  Skeleton,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { DeleteIpAddress, GetIPAddress } from "../../../API/api";
import { enqueueSnackbar } from "notistack";
import AddNewIp from "./AddNewIp";
interface AddEditCategoryType {
  handleClose: () => void;
}
const ManageIp: React.FC<AddEditCategoryType> = ({ handleClose }) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [ipAddressList, setIpAddressList] = useState([]);
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isEditingList, setIsEditingList] = useState<any>([]);
  const [editingList, setEditingList] = useState([]);
  const [addNewIpPopup, setAddNewIp] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editData, setEditData] = useState({});
  useEffect(() => {
    getIpAddresses();
  }, []);
  const handleClosePopup = () => {
    setIsOpen(false);
    handleClose();
  };
  const handleCloseAddEdit = () => {
    setAddNewIp(false);
    getIpAddresses();
  };
  const getIpAddresses = async () => {
    try {
      setIsLoading(true);
      const response = await GetIPAddress();
      const newData = response.data.map((ip: any, index: number) => ({
        ...ip,
        key: ip.ipAddressId,
      }));
      const editingList: any = Array(newData.length).fill(false);
      setEditingList(editingList);

      setIpAddressList(newData);
      setIsLoading(false);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };

  const handleEdit = (rowData: any) => {
    setIsEdit(true);
    setEditData(rowData);
    setAddNewIp(true);
  };
  const handleDelete = (rowData: any) => {
    setIsLoading(true);
    DeleteIpAddress(rowData.key)
      .then((response: any) => {
        enqueueSnackbar("Deleted Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });

        setIsLoading(false);
        getIpAddresses();
      })
      .catch((error: any) => {
        enqueueSnackbar("Error in deleting", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false);
      });
  };
  const addNewIp = () => {
    setIsEdit(false);
    setAddNewIp(true);
  };
  return (
    <div>
      <Modal
        footer={false}
        maskClosable={false}
        title="Manage IP"
        open={isOpen}
        onCancel={handleClosePopup}
      >
        <Button type="primary" onClick={addNewIp}>
          Add
        </Button>
        <List
          size="small"
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={ipAddressList}
          renderItem={(item: any, index) => (
            <List.Item
              actions={[
                <>
                  <Typography.Link onClick={() => handleEdit(item)}>
                    {" "}
                    <EditOutlined />
                  </Typography.Link>
                  <Popconfirm
                    title="Do you want to remove the IP Address?"
                    onConfirm={() => handleDelete(item)}
                  >
                    <a>
                      {" "}
                      <DeleteOutlined />
                    </a>
                  </Popconfirm>
                </>,
              ]}
            >
              <Skeleton avatar title={false} loading={item.loading} active>
                <List.Item.Meta title={item.ipAddress} />
              </Skeleton>
            </List.Item>
          )}
        />
      </Modal>

      {addNewIpPopup && (
        <AddNewIp
          isEdit={isEdit}
          editData={editData}
          handleCloseAddEdit={handleCloseAddEdit}
        />
      )}
    </div>
  );
};
export default ManageIp;
